/**
 * 添加空闲时间任务
 */
type idleTask = (params?: any) => any;
const _idleQueue: idleTask[] = [];
let isIdleListened = false;
function _listenIdle() {
  window.requestIdleCallback(deadline => {
    while (deadline.timeRemaining() > 0 && _idleQueue.length > 0) {
      const task = _idleQueue.pop();
      try {
        task && task();
      } catch (e) {
        setTimeout(() => {
          throw e;
        });
      }
    }
    if (_idleQueue.length > 0) {
      _listenIdle();
    } else {
      isIdleListened = false;
    }
  });
}
function addIdleTask(func: idleTask) {
  if (!window.requestIdleCallback) {
    setTimeout(func, 1);
    return;
  }

  _idleQueue.push(func);

  if (!isIdleListened) {
    isIdleListened = true;
    _listenIdle();
  }
}
export default addIdleTask;
